export default {
  navigation: {
    next: "Volgende",
    back: "Vorige",
    surveyNavigation: "Opname-navigasie",
    workspace: {
      home: "Tuis",
      example: "Voorbeeld"
    }
  }
}
